/*
 * ByLamari: Produktseite des übertragenen Hydrogen-Neubaus (Theme-Kopie B, 25.10.2026), Teil 3.
 *  - „Kombinieren lohnt sich“ auf Ringseiten (components/produkt/Kombinieren.tsx, KombiRinge.tsx): Preisreihe mit
 *    echten Fotos, Wischreihe „Mehr Ringe“ in der gewählten Farbe. Der Kundinnenfoto-Stapel fehlt (keine Fotos).
 *  - „Der Look dazu“ bei Ketten, Ohrringen, Armbändern (components/produkt/DerLook.tsx + Regeln der Expertenrunde
 *    aus routes/look-daten.tsx, hier im Browser gerechnet) mit „Alle in den Warenkorb“.
 * Daten erst, wenn der Bereich auf 400 px herankommt (BL.pdp.daten, sections/bl-pdp-daten).
 */
(function () {
  var BL = (window.BL = window.BL || {});
  var P = BL.pdp;
  if (!P || !P.daten) return;
  var d = P.d, q = P.q, esc = P.esc, geld = P.geld;

  function nahe(el, fn) {
    if (typeof IntersectionObserver === 'undefined') return fn();
    var io = new IntersectionObserver(function (e) { if (e.some(function (x) { return x.isIntersecting; })) { io.disconnect(); fn(); } }, { rootMargin: '400px 0px' });
    io.observe(el);
  }
  function img(u, px, extra, q) { return u ? '<img src="' + esc(P.bildUrl(u, px)) + '"' + (q ? ' srcset="' + esc(P.quadrat(u, q)) + '"' : '') + ' alt="" width="' + (extra || px) + '" height="' + (extra || px) + '" loading="lazy" decoding="async"' + (extra ? '' : ' draggable="false"') + '>' : ''; }
  function sk(liste) { return liste.map(function (v) { return { id: v[0], availableForSale: true, selectedOptions: v[3] ? [{ name: 'Farbe', value: v[3] }] : [] }; }); }

  /* ── Kombinieren (Ringe) ───────────────────────────────────────────── */
  var kombi = q('[data-bl-kombi]');
  if (kombi) {
    var ringe = null;
    var preisSetzen = function () {
      var c = P.v ? P.v.p : 0;
      kombi.querySelectorAll('[data-bl-kp]').forEach(function (s) { s.textContent = geld(c * +s.getAttribute('data-bl-kp')); });
    };
    var stufeSetzen = function () {
      var n = (P.ringe % 3) + 1;
      kombi.querySelectorAll('.bl-kombi-stufe').forEach(function (li, i) {
        if (P.ringe > 0 && i + 1 === n) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
      });
    };
    var kombiZeigen = function () {
      if (!ringe) return;
      var farbe = P.farbe(P.v), f = farbe ? farbe.toLowerCase() : null;
      var alle = ringe.filter(function (r) { return r.v.length > 0; }).map(function (r) {
        var inFarbe = !!f && r.v.some(function (v) { return (v[3] || '').toLowerCase() === f; });
        return {
          handle: r.h, title: r.t, inFarbe: inFarbe, farbe: inFarbe ? farbe : (r.v[0][3] || null),
          bild: (inFarbe && f ? r.fb[f] : null) || r.f, preis: r.v[0][2], varianten: sk(r.v),
          ziel: inFarbe && farbe && r.v.length > 1 ? '/products/' + r.h + '?Farbe=' + encodeURIComponent(farbe) : '/products/' + r.h
        };
      });
      var dieser = alle.filter(function (k) { return k.handle === d.h; })[0] || null;
      var andere = alle.filter(function (k) { return k.handle !== d.h; });
      var passend = f ? andere.filter(function (k) { return k.inFarbe; }) : andere;
      andere = passend.concat(f ? andere.filter(function (k) { return !k.inFarbe; }) : []);
      var fotos = [dieser].concat(andere.slice(0, 2));
      kombi.querySelectorAll('.bl-kombi-stufe').forEach(function (li) {
        li.querySelectorAll('.bl-kombi-stufe__foto').forEach(function (s, i) { s.innerHTML = fotos[i] && fotos[i].bild ? img(fotos[i].bild, 144, 72, 84) : ''; });
      });
      var titel = farbe && passend.length >= 4 ? 'Mehr Ringe in ' + farbe : 'Mehr Ringe zum Kombinieren';
      q('.bl-kombi-reihe__titel', kombi).textContent = titel;
      var liste = q('.bl-kombi-reihe__liste', kombi);
      liste.removeAttribute('aria-busy');
      liste.innerHTML = andere.slice(0, 12).map(function (k) {
        return '<li class="bl-kombi-reihe__karte"><a href="' + esc(k.ziel) + '" class="bl-kombi-reihe__link"><span class="bl-kombi-reihe__bild">' + img(k.bild, 320, 0, 170) +
          '</span><span class="bl-kombi-reihe__name">' + esc(k.title) + '</span><span class="bl-kombi-reihe__meta">' + (k.farbe ? '<span>' + esc(k.farbe) + '</span>' : '') +
          P.gp(k.preis, true, true, geld(k.preis)) + '</span></a>' + P.schnell(k.title, k.varianten, true, k.inFarbe ? farbe : null) + '</li>';
      }).join('') + '<li class="bl-kombi-reihe__karte bl-kombi-reihe__alle"><a href="' + (farbe ? '/collections/ringe?farbe=' + encodeURIComponent(farbe) : '/collections/ringe') +
        '" class="bl-kombi-reihe__link"><span class="bl-kombi-reihe__bild"><span>Alle Ringe ansehen</span></span></a></li>';
      P.gpMerken(liste);
    };
    nahe(kombi, function () { P.daten('ringe').then(function (r) { if (r) { ringe = r; kombiZeigen(); } }); });
    document.addEventListener('bl:pdp-variante', function () { preisSetzen(); kombiZeigen(); });
    document.addEventListener('bl:warenkorb', stufeSetzen);
  }

  /* ── Der Look dazu (Ketten, Ohrringe, Armbänder) ───────────────────── */
  var look = q('[data-bl-look]');
  if (!look || !P.look) return;
  var TIPP_FERTIG = 'Stöbere in Ketten, Ohrringen, Ringen und Armbändern und kombiniere frei.';
  var pool = null, imKorb = [], laeuft = false, daten = null;
  function zeigeLook() {
    if (!pool) return;
    var dies = pool.filter(function (s) { return s.p.h === d.h; })[0];
    var inhalt = q('[data-bl-look-inhalt]', look);
    daten = dies ? P.look.zusammen(dies, pool, P.farbe(P.v)) : { teile: [] };
    var teile = daten.teile, andere = teile.filter(function (t) { return !t.istDieses; });
    if (!andere.length) { inhalt.innerHTML = '<p class="bl-look__intro">' + TIPP_FERTIG + '</p>'; return; }
    var html = '<p class="bl-look__intro"><span>Ausgesucht nach Motiv und Farbe</span>' + (daten.motiv ? '<span class="bl-look__chip">Motiv: ' + esc(daten.motiv) + '</span>' : '') +
      (daten.kollektion ? '<span class="bl-look__chip">' + esc(daten.kollektion.titel) + '</span>' : '') + '</p><ul role="list" class="bl-look__raster" data-anzahl="' + teile.length + '">';
    teile.forEach(function (t) {
      var inn = '<span class="bl-look__bild">' + img(t.bild, 360) + '</span><span class="bl-look__name">' + esc(t.title) + '</span><span class="bl-look__meta">' +
        (t.farbe ? '<span>' + esc(t.farbe) + '</span>' : '') + P.gp(t.preis, t.art === 'ring', t.art === 'ring', geld(t.preis)) + '</span>';
      html += '<li class="bl-look__teil' + (t.istDieses ? ' is-dieses' : '') + '">' + (t.istDieses ? '<div class="bl-look__link">' + inn + '</div>' : '<a href="' + esc(t.ziel) + '" class="bl-look__link">' + inn + '</a>') +
        '<span class="bl-look__art">' + (t.istDieses ? 'Dein Stück' : t.artName) + '</span>' +
        (t.istDieses ? '' : P.schnell(t.title, sk(t.varianten.map(function (v) { return [v.id, true, v.preis, v.farbe]; })), true, t.farbe)) + '</li>';
    });
    html += '</ul><div class="bl-look__kasse" data-bl-look-kasse></div>' + (daten.kollektion ? '<a href="/collections/' + esc(daten.kollektion.handle) + '" class="bl-text-link bl-look__mehr">Alles aus ' + esc(daten.kollektion.titel) + ' ansehen</a>' : '');
    inhalt.innerHTML = html;
    P.gpMerken(inhalt);
    kasse();
  }
  function kasse() {
    var k = q('[data-bl-look-kasse]', look);
    if (!k || !daten) return;
    var teile = daten.teile, dies = teile.filter(function (t) { return t.istDieses; })[0];
    var drin = !!dies && imKorb.indexOf(dies.varianteId) > -1;
    var zu = drin ? teile.filter(function (t) { return !t.istDieses; }) : teile;
    var frei = true, summe = 0;
    zu.forEach(function (t) {
      if (t.art === 'ring' && frei && P.max >= 0 && t.preis <= P.max) { frei = false; return; }
      summe += t.preis;
    });
    var meldung = k.querySelector('[aria-live]');
    k.innerHTML = '<p class="bl-look__summe"><span>' + (drin ? zu.length + ' passende Teile' : 'Ganzer Look, ' + zu.length + ' Teile') + '</span><strong>' + geld(summe) + '</strong></p>' +
      '<button type="button" class="bl-button bl-look__alle" data-bl-look-alle' + (laeuft ? ' disabled aria-busy="true"' : '') + '>' + (drin ? 'Die ' + zu.length + ' dazulegen' : 'Alle ' + zu.length + ' in den Warenkorb') + '</button>' +
      (summe >= 3900 ? '<p class="bl-look__hinweis">Damit ist dein Versand kostenlos.</p>' : '') + '<span class="sr-only" aria-live="polite">' + (meldung ? meldung.textContent : '') + '</span>';
    k._blZu = zu;
  }
  look.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bl-look-alle]');
    if (!b || laeuft || !BL.inDenWarenkorb) return;
    var k = q('[data-bl-look-kasse]', look), zu = k._blZu || [];
    laeuft = true; kasse();
    BL.inDenWarenkorb(zu.map(function (t) { return { id: t.varianteId, quantity: 1 }; }))
      .then(function () { laeuft = false; kasse(); k.querySelector('[aria-live]').textContent = zu.length + ' Teile liegen im Warenkorb.'; })
      .catch(function () { laeuft = false; kasse(); });
  });
  document.addEventListener('bl:warenkorb', function (e) { imKorb = (e.detail.cart.items || []).map(function (i) { return i.variant_id; }); kasse(); });
  document.addEventListener('bl:gratis', kasse);
  document.addEventListener('bl:pdp-variante', zeigeLook);
  nahe(look, function () {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { imKorb = c.items.map(function (i) { return i.variant_id; }); kasse(); }).catch(function () {});
    P.daten('alle').then(function (l) {
      if (!l) { q('[data-bl-look-inhalt]', look).innerHTML = '<p class="bl-look__intro">' + TIPP_FERTIG + '</p>'; return; }
      pool = P.look.bauePool(l);
      zeigeLook();
    });
  });
})();